import React from 'react';
import Row from 'react-bootstrap/Row';
import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed';
// import Image from 'react-bootstrap/Image';
import ReactPlayer from 'react-player/lazy'
import { LogoVideo, PosterUrl } from '../constants';

const Hero = () => {
    return (
        <Row style={{ borderTop: "1px solid rgba(255,255,255,.1)" }}>

            <div style={{ width: 1140, height: 'auto' }}>
                <ResponsiveEmbed aspectRatio="16by9">

                    {/* 2020 At Home */}

                    {/* <iframe id="liveVideo" width="560" height="315" src="https://www.youtube.com/embed/CXb741Vggos?autoplay=1&playsinline=1" frameborder="0" allow="muted accelerometer; autoplay=1; encrypted-media; gyroscope; picture-in-picture" allowfullscreen scrolling="no"></iframe> */}

                    {/* 2021 At Home */}
                    <iframe id="liveVideo" width="560" height="315" src="https://www.youtube.com/embed/4AqMlCNd7XU?autoplay=1&playsinline=1" frameBorder="0" allow="muted accelerometer; autoplay=1; encrypted-media; gyroscope; picture-in-picture" allowFullScreen scrolling="no" title="YouTube live video player"></iframe>
                </ResponsiveEmbed>
            </div>

        </Row>
    );
}
export default Hero;